import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { SuccessDialogData } from './success-dialog.data';

@Component({
    selector : 'success-dialog',
    template: require('./success-dialog.component.html'),
    styles: [require('./success-dialog.component.scss')]
})
export class SuccessDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<SuccessDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SuccessDialogData) {
    }

    public close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/success-dialog/success-dialog.component.ts